import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SupportedLocale } from "@/i18n";
import { MergedDisplayData } from "../types";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface CreditsAccordionProps {
  displayData: MergedDisplayData;
  isPhotoMaster: boolean;
  isTirage: boolean;
  locale: SupportedLocale;
  t: (key: string) => string;
}

export function CreditsAccordion({
  displayData,
  isPhotoMaster,
  isTirage,
  locale: _locale,
  t,
}: CreditsAccordionProps) {
  // Photo master / tirage : crédits gérés ailleurs.
  if (isPhotoMaster || isTirage) {
    return null;
  }

  const oeuvre = displayData?.oeuvresCreditsCreditOeuvre?.trim() ?? "";
  const photo = displayData?.oeuvresCreditsCreditPhotoOeuvre?.trim() ?? "";
  // `oeuvresCreditsRemarqueCreditsDroits` est un champ interne (droits), non
  // destiné à l'affichage public : on ne l'affiche pas dans les crédits.
  const creditLine = [oeuvre, photo].filter(Boolean).join(" | ");

  if (!creditLine) {
    return null;
  }

  return (
    <AccordionItem value="credits">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleArtworkSubtitleCredits")}
      </AccordionTrigger>
      <AccordionContent className="flex flex-col gap-2">
        {creditLine ? <p>{creditLine}</p> : null}
      </AccordionContent>
    </AccordionItem>
  );
}
